module.exports = __webpack_public_path__ + "img/agua.da89cb44.png";